import React from 'react';
import {
    BrowserRouter as Router,
    Route,
} from "react-router-dom";
import Home from './Home';
import Art from '../containers/Art';
import Science from '../containers/Science';
import Info from './Info';
import Sight from '../containers/Sight';
import Menu from '../containers/Menu';

export default () => {
	return (
	  	<Router>	
			<div id="app">
                <Menu />
				<Route exact path="/" component={ Home }/>

                <Route path="/about/" render={ () => (
                    <Sight />
                ) }/>

				<Route exact path="/art/:id?" render={ ({ match }) => (
					<Art id={ match.params.id }/>
				)} />
				
				<Route exact path="/science" component={ Science }/>
                
                <Route exact path="/contact" component={ Info }/>
                
			</div>
		</Router>
	)	
}



// WEBPACK FOOTER //
// ./src/components/App.js